import React from 'react';

/*
  Para her yerde aynı biçimde yazılır: tabular rakamlar, sabit ondalık
  sütun, para birimi işareti bir tık küçük ve soluk. Böylece alt alta
  gelen tutarlar dikey bir kenar oluşturur ve göz taramak zorunda kalmaz.
*/

export function formatTRY(n) {
  return Math.round(Number(n) || 0).toLocaleString('tr-TR');
}

export default function Money({
  value,
  tone,            // 'pos' | 'neg' | undefined (nötr)
  size = 'md',     // 'lg' | 'md' | 'sm'
  sign = false,    // + / − öneki göster
  currency = '₺',
  className = '',
  style,
}) {
  const num = Number(value) || 0;
  const toneClass = tone === 'pos' ? ' figure-pos' : tone === 'neg' ? ' figure-neg' : '';
  const sizeClass = size === 'lg' ? ' figure-lg' : size === 'sm' ? ' figure-sm' : '';

  // sign=true  → her zaman + veya − (gelir/gider satırları: tutar pozitif gelir,
  //              yön "tone" ile belirtilir)
  // sign=false → yalnız negatif değerde −. İşaret asla renge bırakılmaz.
  const prefix = sign
    ? ((tone === 'neg' || num < 0) ? '−' : '+')
    : (num < 0 ? '−' : '');

  return (
    <span className={`figure${sizeClass}${toneClass}${className ? ' ' + className : ''}`} style={style}>
      {prefix}
      <span className="unit">{currency}</span>
      {formatTRY(Math.abs(num))}
    </span>
  );
}
